import axios from "axios";
import React, {useEffect, useState} from "react";

const Organization = () => {
    const [Organizations, setOrganizations] = useState({})
    const [Admin, setAdmin] = React.useState(false);
    let bedrijf

    useEffect( () => {
        const getAll = async () => {
            try {
                const organizations = await axios.get(`/api/organization/get`);
                setOrganizations(organizations.data);
            } catch (error) {
                console.log(error);
            }
        }
        getAll();
    }, []);

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const response = await axios.get('/api/auth/validate-token', { withCredentials: true });
                const user = response.data.user.organization;
                if (user === "admin") {
                    setAdmin(true)
                }
            } catch (error) {
                console.log(error)
            }
        };
        checkAuth();
    }, []);

    const DeleteOrganisation = async () => {
        document.getElementById("popup").style.display = "none";
        window.location.reload();
        await axios.delete(`/api/organization/delete/`, {
            params: {
                name: bedrijf
            }
        });
    }

    const confirmDeleteOrganisation = async (event, naam) => {
        document.getElementById("popup").style.display = "flex";
        bedrijf = naam;
    }

    const cancelDeleteOrganisation = async () => {
        document.getElementById("popup").style.display = "none";
    }

    const disableOne = async (e) => {
        await axios.get(`/api/organization/disable/`, {
            params: {
                name: e.target.value
            }
        });
    }

    return (
        <div className="flex flex-col items-center gap-4">
            <dialog open id={"popup"} className={"hidden shadow-sm shadow-gray-400 bg-gray-200 rounded-2xl p-3 w-72 fixed z-50 text-center gap-4 flex-col"}>
                <p className={"font-bold text-2xl"}>Weet je zeker dat je dit bedrijf wilt verwijderen</p>
                <div className="flex items-center justify-around">
                    <button className={"p-2 bg-blue-500 rounded-full text-xl font-bold text-white w-16"} onClick={DeleteOrganisation}>Ja</button>
                    <button className={"p-2 bg-blue-500 rounded-full text-xl font-bold text-white w-16"} onClick={cancelDeleteOrganisation}>Nee</button>
                </div>
            </dialog>
            <a href={"/"} className={"ml-2 mt-2 font-extrabold text-xl text-white absolute bg-orange-500 rounded-lg h-fit p-1.5 shadow-xl shadow-gray-400 left-4"}>Terug</a>
            {Organizations.length > 0 ? Organizations.map((organization) => (
                <div className="flex flex-col p-4 px-10 pr-40 relative items-start gap-3 border-b xl:w-10/12 md:w-10/12 w-10/12 border-stone-800">
                    <div className={"text-5xl font-bold"} key={organization.name}>{organization.clean}</div>
                    <div className={"text-3xl"}>{organization.code}</div>
                    {Admin ?
                        <div className={"absolute  md:flex hidden right-10 top-8 "}>
                            <button onClick={(e) => disableOne(e)} value={organization.name} className={ organization.isActive ? "w-14 h-14 rounded-full shadow-xl shadow-gray-400 p-3.5 bg-green-600" : "w-14 h-14 rounded-full shadow-xl shadow-gray-400 p-3.5 bg-red-600"}></button>
                            <img onClick={(event) => confirmDeleteOrganisation(event, organization.name)} className="h-14 w-14 hover:cursor-pointer" src="/delete.svg" alt="delete"/>
                        </div>
                        : ""}
                </div>
            )) : ""}
            {Admin ?
                    <a href={"/organization/nieuw"} className="fixed right-3 bottom-3 w-14 h-14 rounded-full bg-green-600 shadow-xl shadow-gray-400 p-3.5">
                        <img src={"/Add.svg"} alt={""}/>
                    </a>
                : ""}
        </div>
    )
}

export default Organization;